import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  approvedRequestSO: null,
  loading: false,
  error: null,
};

const approvedRequestSOSlice = createSlice({
  name: "approvedRequestSO",
  initialState,
  reducers: {
    fetchApprovedRequestSOStart: (state) => {
      state.loading = true;
      state.error = null;
    },

    fetchApprovedRequestSOSuccess: (state, action) => {
      state.loading = false;
      state.approvedRequestSO = action.payload;
      state.error = null;
    },

    fetchApprovedRequestSOFailure: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  fetchApprovedRequestSOStart,
  fetchApprovedRequestSOSuccess,
  fetchApprovedRequestSOFailure,
} = approvedRequestSOSlice.actions;

export default approvedRequestSOSlice.reducer;